import { Box, Typography } from "@mui/material";
import useColors from "api/hooks/useColors";
import StyledDataGrid from "components/StyledDataGrid";
import iconMapping from "icons/IconMapping";
import { getEntityTypeDisplayName } from "utils/utils";

const EntitiesByTypeTableWidget = ({ summary, isLoading }) => {
  const colors = useColors();
  const entitiesByTypeRows = summary?.entities_by_type
    ? Object.entries(summary.entities_by_type).map(
        ([entityType, count], idx) => ({
          id: idx,
          entity_type: entityType,
          count: count,
        })
      )
    : [];

  const entityColumns = [
    {
      field: "entity_type",
      headerName: "Entity Type",
      flex: 1,
      renderCell: (params) => {
        const Icon = iconMapping[params.value] || iconMapping["Internet"];
        const displayName = getEntityTypeDisplayName(params.value);
        return (
          <Box display="flex" alignItems="center" gap={1.5}>
            <Icon
              style={{
                color: colors.text_primary,
                width: "20px",
                height: "20px",
              }}
            />
            <Typography variant="body2" sx={{ fontSize: "13px" }}>
              {displayName}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "count",
      headerName: "Count",
      flex: 0.5,
      renderCell: (params) => (
        <Typography variant="body2" sx={{ fontSize: "13px" }}>
          {params.value}
        </Typography>
      ),
    },
  ];

  return (
    <Box sx={{ height: "100%" }}>
      <StyledDataGrid
        rows={entitiesByTypeRows}
        columns={entityColumns}
        loading={isLoading}
        disableRowSelectionOnClick
        pageSizeOptionsOverride={[10, 25, 50]}
      />
    </Box>
  );
};

export default EntitiesByTypeTableWidget;
